module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 4-f1d9940a1a901c70027b06d6a5ef6c97.jpg";